import StatusTag from 'components/ui/base/status/StatusTag';
import { JobStatuses } from 'store/jobs/job';
import { JOB_STATUS_COLOR_MAP, JobStatusConfig } from 'store/jobs/utils';

type Props = {
    status: JobStatuses;
    dataTestId?: string;
};

const DEFAULT_STATUS: JobStatusConfig = {
    label: 'Unknown Status',
    color: 'var(--orange-6)',
};

const JobStatus = ({ status, dataTestId }: Props) => {
    const { label, color } = JOB_STATUS_COLOR_MAP[status] ?? DEFAULT_STATUS;

    return <StatusTag dataTestId={dataTestId} color={color} status={label} />;
};

export default JobStatus;
